import { ApplicantStatus } from "shared/types";
import { cx } from "shared/utils";

export const VerificationProgress = ({
  totalVerifications = 0,
  completedVerifications = 0,
  status,
  className
}: {
  totalVerifications: number;
  completedVerifications: number;
  status: ApplicantStatus;
  className?: string;
}) => {
  return (
    <div className={cx(className, "h-2 rounded bg-alpha-40 w-full")}>
      <div
        className={cx(
          "h-2 rounded",
          status === ApplicantStatus.Submitted
            ? "bg-success-500"
            : "golden-candybar"
        )}
        style={{
          width: `${
            totalVerifications > 0
              ? Math.max(
                  0,
                  Math.min(
                    100,
                    (completedVerifications / totalVerifications) * 100
                  )
                )
              : 0
          }%`
        }}
      />
    </div>
  );
};
